import { render, staticRenderFns } from "./LegalEntityProfilePublic.vue?vue&type=template&id=fed761cc&scoped=true&"
import script from "./LegalEntityProfilePublic.vue?vue&type=script&lang=js&"
export * from "./LegalEntityProfilePublic.vue?vue&type=script&lang=js&"
import style0 from "./LegalEntityProfilePublic.vue?vue&type=style&index=0&id=fed761cc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fed761cc",
  null
  
)

export default component.exports